<script setup>
</script>

<template>
  <div id="toast-container" class="toast-container position-fixed p-3 bottom-0 start-50 translate-middle-x"></div>
  <footer id="footer" class="footer dark-background">
    <div class="container">
      <h3>{{ $t('main.siteName') }}<span>.</span></h3>
      <p>{{ $t('main.hero.title') }}</p>
      <div class="copyright d-flex justify-content-center align-items-center">
        <div>
          <span>Copyright</span><strong class="px-1">Emerging Services Limited.</strong><span>{{ $t('main.allRightsReserved') }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>

.footer {
  color: var(--default-color);
  background-color: var(--background-color);
  background: url("/assets/img/footer-bg.jpg") no-repeat center center;
  background-size: cover;
  font-size: 14px;
  text-align: center;
  padding: 60px 0 30px 0;
  position: relative;
}

.footer:before {
  content: "";
  background: color-mix(in srgb, var(--background-color), transparent 20%);
  position: absolute;
  inset: 0;
}

.footer .container {
  position: relative;
}

.footer h3 {
  font-size: 36px;
  font-weight: 700;
  position: relative;
  padding: 0;
  margin: 0 0 15px 0;
}

.footer p {
  font-size: 15px;
  font-style: italic;
  padding: 0;
  margin: 0 0 30px 0;
}

.footer .copyright {
  padding-top: 25px;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.dark-background {
  --background-color: var(--dark-background-color);
  --default-color: #ffffff;
  --heading-color: #ffffff;
  --surface-color: #315575;
  --contrast-color: #223b51;
}

@media (max-width: 767px) {
  h3 {
    font-size: 30px !important;
    margin: 0 0 5px 0 !important;
  }

  .footer {
    padding: 5px 0 5px 0;
  }

  .footer p {
    margin: 0 0 10px 0;
  }

  .footer .copyright {
    padding-top: 5px !important;
    font-size: 12px;
  }
}
</style>